import Types from "./Types";

export const getEnrolledCoursesRequest = (body) => ({
  type: Types.GET_ENROLLED_COURSES_REQUEST,
  payload: body,
});

export const getEnrolledCoursesSuccess = (data) => ({
  type: Types.GET_ENROLLED_COURSES_SUCCESS,
  payload: data,
});

export const getEnrolledCoursesFail = () => ({
  type: Types.GET_ENROLLED_COURSES_FAIL,
});

export const getPendingCoursesRequest = (body) => ({
  type: Types.GET_PENDING_COURSES_REQUEST,
  payload: body,
});

export const getPendingCoursesSuccess = (data) => ({
  type: Types.GET_PENDING_COURSES_SUCCESS,
  payload: data,
});

export const getPendingCoursesFail = () => ({
  type: Types.GET_PENDING_COURSES_FAIL,
});

export const enrolledCourseRequest = (body) => ({
  type: Types.ENROLLED_COURSE_REQUEST,
  payload: body,
});

export const enrolledCourseSuccess = (data) => ({
  type: Types.ENROLLED_COURSE_SUCCESS,
  payload: data,
});

export const enrolledCourseFail = () => ({
  type: Types.ENROLLED_COURSE_FAIL,
});

export const addCourseLoading = (isLoading) => ({
  type: Types.ADD_COURSES_LOADING,
  payload: isLoading,
});
